import { jsx as _jsx } from "react/jsx-runtime";
import { useAudioPlayer } from "expo-audio";
import { Easing, interpolate, interpolateColor, useAnimatedStyle, useSharedValue, withDelay, withRepeat, withTiming } from "react-native-reanimated";
import CorrectAudio from "../../assets/CorrectAudio.mp3";
import IncorrectAudio from "../../assets/IncorrectAudio.mp3";
import { catchChromeAutoplayError } from "../../lib/catchChromeAutoplayError";
import { useTheme } from "../../styles";
import { Button } from "../Button";
/**
 * When incorrect choice is selected
 *
 * - Button turns red (system/status/danger)
 * - Button slides left and right
 * - Button makes an
 * [error noise](https://drive.google.com/file/d/1OuZfOPC4dH1-auBnGiv6AwhO5onD77c8/view?usp=sharing)
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̄̉̀̀̆̎̀̀̆̌̀̀̆̉̀̀̆̎̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̆̀̀̃̃̀̀̃̄̀̀̆̃̀̀̃̈̀̀̃̈̀̀̃̉̀̀̃̄̀̀̂̍̀̀̃̀̀̀̃̇̀̀̆̄̀̀̆̂̀̀̂̍̀̀̃̄̀̀̆̅̀̀̆̃̀̀̆̃̀̀̂̍̀̀̆̂̀̀̃̅̀̀̃̄̀̀̆̄̀̀̂̍̀̀̃̂̀̀̆̆̀̀̃̅̀̀̃̄̀̀̃̆̀̀̆̄̀̀̃̄̀̀̆̆̀̀̆̄̀̀̆̃̀̀̃̄̀̀̃̀̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̇̍̀̀̇̍}&#x20;
 *
 * When correct choice is selected
 *
 * - Button turns green (system/status/success)
 * - Button bounces up and down
 * - Button makes a
 * [celebration sound](https://drive.google.com/file/d/1cYJ9gUO5Sfv5gwSmI5AMLeXZSQ2vd6tW/view?usp=sharing)
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̄̉̀̀̆̎̀̀̆̌̀̀̆̉̀̀̆̎̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̄̀̀̆̂̀̀̃̅̀̀̆̄̀̀̆̅̀̀̆̃̀̀̃̈̀̀̂̍̀̀̃̇̀̀̃̈̀̀̃̆̀̀̆́̀̀̂̍̀̀̃̄̀̀̃́̀̀̃̀̀̀̃̀̀̀̂̍̀̀̃̉̀̀̃̆̀̀̃̈̀̀̃̂̀̀̂̍̀̀̆́̀̀̆̅̀̀̆̃̀̀̆̄̀̀̆̄̀̀̃̇̀̀̃́̀̀̆̂̀̀̆̅̀̀̃̈̀̀̃̈̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̇̍̀̀̇̍}&#x20;
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-32}
 */ export var CorrectIncorrectButton = function(param) {
    var text = param.text, onPress = param.onPress, correct = param.correct;
    var theme = useTheme().theme;
    var colorProgress = useSharedValue(0);
    var shakeProgress = useSharedValue(0);
    var audioPlayer = useAudioPlayer(correct ? CorrectAudio : IncorrectAudio);
    var style = useAnimatedStyle(function() {
        var color = interpolateColor(colorProgress.get(), [
            0,
            1
        ], [
            theme.color.primary100,
            correct ? theme.color.success : theme.color.danger
        ]);
        var translate = interpolate(shakeProgress.get(), [
            0,
            1 / 3,
            2 / 3,
            1
        ], [
            0,
            10,
            -10,
            0
        ]);
        return {
            borderColor: color,
            backgroundColor: color,
            transform: [
                correct ? {
                    translateY: translate
                } : {
                    translateX: translate
                }
            ]
        };
    }, [
        colorProgress,
        correct
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        _useAnimated: true,
        testID: correct ? 'CorrectIncorrectButton_correct' : 'CorrectIncorrectButton_incorrect',
        style: style,
        text: text,
        onPress: function() {
            var animationDelay = 300;
            setTimeout(function() {
                void catchChromeAutoplayError(function() {
                    return audioPlayer.play();
                });
            }, animationDelay);
            colorProgress.set(withTiming(1));
            shakeProgress.set(withDelay(animationDelay, withRepeat(withTiming(1, {
                easing: Easing.inOut(Easing.linear)
            }), 3, false)));
            return onPress === null || onPress === void 0 ? void 0 : onPress();
        },
        variant: "solid",
        textStyle: {
            textAlign: 'center'
        }
    });
};
